import { Theme } from 'config';

const styles = (theme: Theme) => ({
  grid: {
    position: 'relative',
    margin: '0 !important',
    width: '100% !important',
  },
  container: {
    width: '100% !important',
    justifyContent: 'center !important',
  },
  loading: {
    '&&': {
      width: '100% !important',
    },
  },
  onboardingMsg: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    color: `${theme.darkGray} !important`,
    margin: '.5rem !important',
    '& p': {
      margin: '.25rem .5rem !important',
    },
  },
  onboardingMsgTitle: {
    color: `${theme.deepPurple}`,
  },
});

export default styles;
